import NewExpense from "./NewExpense";

export default NewExpense;
